import { lazy } from 'react';

export const SettingsLandingPage = lazy(() => import('./SettingsLandingPage'));
